module.exports = __webpack_public_path__ + "static/media/ecolibrium.08f8b2ae.svg";